<div class="vt-toast-container">
  @for (toast of vtToastMessages; track $index) {
    <div class="vt-toast" [ngClass]="toast.type">
      <button class="btn-close" aria-label="Close" (click)="closeToast(toast)"></button>
      <div class="header">
        @if (toast.type == 'success') {
          <svg class="icone" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
            viewBox="0 0 33 33" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M31.3211 16.6938C31.3211 24.7939 24.7546 31.3604 16.6545 31.3604C8.55428 31.3604 1.98779 24.7939 1.98779 16.6938C1.98779 8.59359 8.55428 2.0271 16.6545 2.0271C24.7546 2.0271 31.3211 8.59359 31.3211 16.6938ZM22.9308 12.4173C23.4515 12.938 23.4515 13.7822 22.9308 14.3029L16.2641 20.9696C16.2005 21.0331 16.1321 21.089 16.06 21.137C16.0399 21.1504 16.0195 21.1633 15.9988 21.1755C15.4874 21.4777 14.8177 21.4091 14.3783 20.9697L10.3783 16.9697C9.85757 16.449 9.85757 15.6048 10.3783 15.0841C10.899 14.5634 11.7432 14.5634 12.2639 15.0841L15.3211 18.1413L21.0451 12.4173C21.5658 11.8966 22.4101 11.8966 22.9308 12.4173Z"
              fill="#08A159" />
          </svg>
        }
        @if (toast.type == 'error') {
          <svg class="icone" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
            viewBox="0 0 33 33" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M31.3211 16.6938C31.3211 24.7939 24.7546 31.3604 16.6545 31.3604C8.55428 31.3604 1.98779 24.7939 1.98779 16.6938C1.98779 8.59359 8.55428 2.0271 16.6545 2.0271C24.7546 2.0271 31.3211 8.59359 31.3211 16.6938ZM21.5974 11.7506C22.1181 12.2713 22.1181 13.1155 21.5974 13.6362L18.5401 16.6936L21.5972 19.7507C22.1179 20.2714 22.1179 21.1156 21.5972 21.6363C21.0765 22.157 20.2323 22.157 19.7116 21.6363L16.6544 18.5792L13.5974 21.6362C13.0767 22.1569 12.2325 22.1569 11.7118 21.6362C11.1911 21.1155 11.1911 20.2713 11.7118 19.7506L14.7688 16.6936L11.7116 13.6363C11.1909 13.1156 11.1909 12.2714 11.7116 11.7507C12.2323 11.23 13.0765 11.23 13.5972 11.7507L16.6544 14.808L19.7118 11.7506C20.2325 11.2299 21.0767 11.2299 21.5974 11.7506Z"
              fill="#D2373C" />
          </svg>
        }
        <h2>{{ toast.title }}</h2>
      </div>
      <div class="text">
        {{ toast.text }}
      </div>
    </div>
  }
</div>
